<div #graphContainer class="col-md-11">
  <svg #graph></svg>
</div>
<div class="col-md-1" style="margin-top: 3%">
  <a class="control-menu" [matMenuTriggerFor]="typeMenu"><i class="zmdi zmdi-hc-2x zmdi-more-vert"></i></a>
</div>
<mat-menu #typeMenu="matMenu">
  <mat-slide-toggle style="padding: 10px 5px" [checked]="showGridLines" (change)="toggleGridLines()"
    (click)="$event.stopPropagation()">
    <span>Grid lines</span>
  </mat-slide-toggle>
</mat-menu>